import { useEffect, useRef } from 'react';
import { CheckCircle } from 'lucide-react';

interface ToastProps {
  message: string;
  onDismiss: () => void;
}

export default function Toast({ message, onDismiss }: ToastProps) {
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss;

  useEffect(() => {
    const t = setTimeout(() => onDismissRef.current(), 4000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="fixed bottom-[80px] left-1/2 z-[200] flex -translate-x-1/2 items-center gap-3 rounded-lg bg-gray-900 px-4 py-3 text-white shadow-lg">
      <CheckCircle size={18} className="shrink-0 text-green-400" />
      <span className="whitespace-nowrap text-sm font-medium">{message}</span>
    </div>
  );
}
